export enum APP_MODE {
  full = 1,
  light = 2,
}
